let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("e7iBs")).then(() => parcelRequire('8LFOm'));